import React from "react";
export default function IdCardGenerator() {
  return (
    <div className="dashboard-wrapper">
      <h2>ID Card Generator</h2>
      <p>Generate and print ID cards for students here.</p>
      {/* Implement ID card generation here */}
    </div>
  );
}